module.exports = __webpack_public_path__ + "static/img/MathWallet_Logo_Horizontal_White.bd812ce0.png";